import { graphql } from "gql.tada";
import { AccessibleMediaFragment } from "./AccessibleMediaFragment";

export const ArticleSideBySideImageFragment = graphql(
  /* GraphQL */ `
    fragment ArticleSideBySideImageFragment on SideBySideMedia {
      _id
      mediaCollection(limit: 2) {
        items {
          ...AccessibleMediaFragment
        }
      }
    }
  `,
  [AccessibleMediaFragment]
);